import React, { useState } from "react";
import { RootState } from "Realty/store";
import { connect } from "react-redux";
import { Modal } from "../../../../../../components/common/Modal";
import { ReactComponent as SortIcon } from "../../../../../../assets/icons/sort.svg";
import "./styles.css";
import { RadioBox } from "../../../../../../components/common/Radiobox";
import { ContractAssignmentActionCreator } from "../../../../../../store/ContractAssignment/actions";
import {
  selectSortingByDate,
  selectSortingByName,
} from "../../../../../../store/ContractAssignment/selectors";

export const _Sorting = ({ byDate, byName, setSortByDate, setSortByName }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <button className="sorting_toggle-button" onClick={() => setIsOpen(true)}>
        <SortIcon stroke="#000" fill="#000" width="20px" height="20px" />
      </button>
      <Modal
        title="Сортировка"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <RadioBox
          label="Сначала новые"
          name="newest"
          value="desc"
          checked={byDate === "desc"}
          onChange={() => setSortByDate("desc")}
        />
        <RadioBox
          label="Сначала старые"
          name="oldest"
          value="asc"
          checked={byDate === "asc"}
          onChange={() => setSortByDate("asc")}
        />
        <RadioBox
          label="По имени (A–Z)"
          name="a-z"
          value="asc"
          checked={byName === "asc"}
          onChange={() => setSortByName("asc")}
        />
        <RadioBox
          label="По имени (Z–A)"
          name="z-a"
          value="desc"
          checked={byName === "desc"}
          onChange={() => setSortByName("desc")}
        />
      </Modal>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  byDate: selectSortingByDate(state),
  byName: selectSortingByName(state),
});

const mapDispatchToProps = {
  setSortByDate: ContractAssignmentActionCreator.setSortByDate,
  setSortByName: ContractAssignmentActionCreator.setSortByName,
};

export const Sorting = connect(mapStateToProps, mapDispatchToProps)(_Sorting);
